export default __webpack_public_path__ + "static/media/enter_ticket_image_back.9711d570.png";